document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  const successMessage = document.querySelector('[data-form-success]');
  if (successMessage) {
    const successUrl = successMessage.dataset.successUrl;
    if (successUrl) {
      try { sessionStorage.setItem('southside_quote_submitted', '1'); } catch (error) { /* Storage may be unavailable. */ }
      window.location.replace(successUrl);
      return;
    }
    successMessage.focus({ preventScroll: true });
    successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  const thankYouPage = document.querySelector('[data-quote-thank-you]');
  if (thankYouPage) {
    let submitted = false;
    try {
      submitted = sessionStorage.getItem('southside_quote_submitted') === '1';
      sessionStorage.removeItem('southside_quote_submitted');
    } catch (error) { /* Storage may be unavailable. */ }

    const sendTo = thankYouPage.dataset.conversionSendTo;
    if (submitted && sendTo && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', { send_to: sendTo });
    }
  }
});

document.addEventListener('DOMContentLoaded',()=>{
 const menu=document.querySelector('[data-mobile-menu]'),toggle=document.querySelector('[data-menu-toggle]');
 const close=()=>{if(menu&&toggle){menu.hidden=true;toggle.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');}};
 if(menu)menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu&&!menu.hidden){close();toggle.focus();}});
 const error=document.querySelector('.form-errors');if(error){error.focus();error.scrollIntoView({block:'center'});}
 const service=document.getElementById('QuoteService');
 const types={'recurring-cleaning':'Recurring cleaning','deep-cleaning':'Deep cleaning','move-in-move-out-cleaning':'Move-in / move-out','pre-listing-cleaning':'Pre-listing cleaning','compassionate-cleaning':'Compassionate cleaning','upholstery-steam-cleaning':'Upholstery and steam spot cleaning','carpet-cleaning':'Carpet cleaning'};
 const suffix=new URLSearchParams(location.search).get('view')||location.pathname.split('/').pop();if(service&&types[suffix])service.value=types[suffix];
});
